import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import AxisX from '../../../../charts/echarts/AxisX'
import { usePipelineDataContextWithVariables } from '../../provider/DDPDataProvider'

function DDPCategoryAxisX ({
  pipeline,
  variables,
  dataAccessor,
  categoryAccessor,
  format,
  ...restProps
}) {
  const { data, isLoading } = usePipelineDataContextWithVariables(pipeline, variables)

  const categories = useMemo(() => {
    if (!data) return []
    const rawData = dataAccessor ? get(data, dataAccessor) : data
    if (!Array.isArray(rawData)) return []

    return rawData.map(item =>
      categoryAccessor ? get(item, categoryAccessor) : item
    )
  }, [data, dataAccessor, categoryAccessor])

  if (isLoading) return null

  return (
    <AxisX
      data={categories}
      format={format}
      {...restProps}
    />
  )
}

DDPCategoryAxisX.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  /** Variables to pass to the pipeline */
  variables: PropTypes.object,

  /** Path to category array in pipeline response (e.g., 'categories', 'data.labels') */
  dataAccessor: PropTypes.string,

  /** Path to category value within each item (e.g., 'name', 'label') */
  categoryAccessor: PropTypes.string,

  /** Format string for formatting categories */
  format: PropTypes.string
}

DDPCategoryAxisX.defaultProps = {
  type: 'category',
  dataAccessor: 'data',
  format: 'title'
}

export default DDPCategoryAxisX
